<template>
    <div
        ref="messageItemContainer"
        class="message-item-container"
        @click="handleClick"
    >
        <div
            v-if="showReadStatus"
            :class="{
                'read-status-dot': true,
                'not-read': [UNREAD, IGNORE].includes(messageData.status),
            }"
        ></div>
        <div class="message-item-right">
            <div class="message-item-header">
                {{ messageData.title }}
            </div>
            <div class="message-item-body" :style="lineClamp">
                <!--bca-disable-->
                <div
                    ref="messageContent"
                    :class="[
                        expand ? 'message-content-expand' : 'message-content',
                    ]"
                    :style="expand ? {} : {maxHeight: 'var(--max-height)'}"
                    v-html="content"
                ></div>
                <!--bca-enable-->
                <div
                    v-if="expandIconVisible"
                    class="expand-icon"
                >
                    <veui-icon :name="expand ? 'chevron-up' : 'chevron-down'"/>
                </div>
            </div>
            <div class="message-item-footer">
                {{ messageData.addTime }}
            </div>
        </div>
    </div>
</template>

<script>
import {Icon} from 'veui';
import {nanoid} from 'nanoid';
import {UNREAD, IGNORE} from '../config';
import 'veui-theme-dls-icons/check-circle';
import 'veui-theme-dls-icons/trash';

const ellipsis = 14; // 省略号宽度
const LINE_HEIGHT = 20;
export default {
    name: 'MessageItem',
    components: {
        'veui-icon': Icon
    },
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        showReadStatus: {
            type: Boolean,
            default: true
        },
        showExpandIcon: {
            type: Boolean,
            default: true
        },
        isShow: {
            type: Boolean,
            default: true
        },
        maxLine: {
            type: Number,
            default: 1
        },
        type: {
            type: String,
            default: 'system' // system 系统消息，personal 我的消息
        }
    },
    data() {
        return {
            UNREAD,
            IGNORE,
            messageData: this.data,
            expand: false,
            rand: nanoid(), // 随机id，用于计算浮动a标签时，生成一个id唯一的浮动元素进行占位,
            expandIconVisible: this.showExpandIcon,
            ellipsisWidth: 0
        };
    },
    computed: {
        lineClamp() {
            return {
                '--line-height': LINE_HEIGHT + 'px',
                '--max-line': this.maxLine,
                '--max-height': this.maxLine * LINE_HEIGHT + 'px',
                '--ellipsis-top': (this.maxLine - 1) * LINE_HEIGHT + 'px',
                '--ellipsis-width': this.ellipsisWidth + 'px'
            };
        },
        content() {
            const ellipsis = `<div id="messageContentEllipsis-${this.rand}"
                class="message-content-ellipsis"></div>`;
            const end = `<span id="messageContentEnd-${this.rand}"></span>`;
            return ellipsis + this.data.content + end;
        }
    },
    watch: {
        data: {
            handler(val) {
                this.messageData = val;
            },
            deep: true
        },
        isShow(val) {
            if (val) {
                this.$nextTick(this.calcFloatLink);
            }
        },
        content() {
            this.$nextTick(this.calcFloatLink);
        }
    },
    methods: {
        handleClick(e) {
            this.handleToggleExpand();
            if (e.target.nodeName === 'A') {
                e.stopPropagation();
                this.$emit('clickLink', this.messageData);
            }
            else {
                this.$emit('click', this.messageData);
            }
        },
        handleToggleExpand() {
            this.expand = !this.expand;
        },
        // 当前文本是否超过最大行数
        calcMessageWidth() {
            const id = `messageContentEnd-${this.rand}`;
            const end = document.getElementById(id);

            // 占位空元素，若超过最大行数，则宽度=省略号宽度
            const ellipsisId = `messageContentEllipsis-${this.rand}`;
            const messageContentEllipsis = document.getElementById(ellipsisId);
            if (end.offsetTop >= this.maxLine * LINE_HEIGHT) {
                this.expandIconVisible = this.showExpandIcon;
                this.ellipsisWidth = ellipsis;
                messageContentEllipsis.style.display = 'block';
                messageContentEllipsis.style.width = this.ellipsisWidth + 'px';
            }
            else {
                this.expandIconVisible = false;
                this.ellipsisWidth = 0;
                messageContentEllipsis.style.display = 'none';
                messageContentEllipsis.style.width = '';
            }
        },
        calcFloatLink() {
            const container = this.$refs.messageItemContainer;
            const containerWidth = container.clientWidth;
            const padding = 8 + 8;
            const expandIconWidth = this.showExpandIcon ? (18 + 4) : 0;
            const readStatusWidth = this.showReadStatus ? (5 + 8) : 0;
            const clientWidth = containerWidth - padding - expandIconWidth - readStatusWidth;

            const content = this.$refs.messageContent;
            const childNodes = content.childNodes;

            this.calcMessageWidth(content);

            if (childNodes.length <= 3) {
                // 只有 #messageContentEllipsis,#messageContentEnd 和文本
                return;
            }
            let floatLinkWidth = 0; // 记录浮动展示的a标签宽度
            for (let i = childNodes.length - 1; i >= 0; i--) {
                const item = childNodes[i];
                if (item.nodeName === 'A') {
                    // 重置a标签状态
                    item.classList.remove('a-float');
                    item.style.right = '';
                    item.style.left = '';
                    // 超出最大展示行数，被隐藏，链接需要浮动展示在文本结尾
                    if (item.offsetTop >= this.maxLine * LINE_HEIGHT) {
                        item.classList.add('a-float');
                        item.style.right = floatLinkWidth + 'px';
                        floatLinkWidth += item.offsetWidth;
                    }
                    // 浮动展示的链接会遮挡当前item
                    else if (floatLinkWidth + item.offsetLeft + item.offsetWidth >= clientWidth) {
                        item.classList.add('a-float');
                        item.style.right = floatLinkWidth + 'px';
                        floatLinkWidth += item.offsetWidth;
                    }
                }
            }

            // 占位空元素，宽度 = 浮动a标签 + 省略号
            const id = `messageContentEllipsis-${this.rand}`;
            const messageContentEllipsis = document.getElementById(id);
            if (floatLinkWidth > 0) {
                messageContentEllipsis.style.display = 'block';
                this.ellipsisWidth = Math.min(clientWidth, floatLinkWidth + ellipsis);
                messageContentEllipsis.style.width = this.ellipsisWidth + 'px';

                // 浮动展示的链接超出容器宽度，需要调整定位方式，向左对齐
                if (floatLinkWidth > clientWidth) {
                    let leftWidth = 0;
                    for (let i = 0; i < childNodes.length; i++) {
                        const item = childNodes[i];
                        if (item.nodeName === 'A' && item.classList.contains('a-float')) {
                            item.style.left = leftWidth + 'px';
                            item.style.right = '';
                            leftWidth += item.offsetWidth;
                        }
                    }
                }
            }
        }
    },
    mounted() {
        const container = this.$refs.messageItemContainer;
        this.$erd.listenTo(container, element => {
            this.$nextTick(() => {
                this.calcFloatLink();
            });
        });
        this.$nextTick(() => {
            this.calcFloatLink();
        });

    },
    beforeDestroy() {
        const container = this.$refs.messageItemContainer;
        this.$erd.uninstall(container);
    }
};
</script>

<style scoped lang="less">
.message-item-container {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 8px;
    overflow: hidden;
    cursor: pointer;
    padding: 0 8px;
    border-radius: var(--Radius-r2, 10px);
    &:hover {
        background-color: var(--2-1-G3, #F6F7FB);
    }
    .read-status-dot {
        margin-top: 7.5px;
        flex-shrink: 0;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: var(--2-2-G2, #EBEDF5);
        &.not-read {
            background-color: var(--Red-7, #F53F3F);

        }
    }
    .message-item-right {
        flex: 1;
        display: flex;
        justify-content: center;
        flex-direction: column;
        gap: 8px;
        flex-shrink: 1;
        flex-grow: 1;
        max-width: 100%;
    }
    .message-item-header {
        color: var(----G9, #191B1E);
        font-size: 14px;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
    }
    .message-item-body {
        position: relative;
        display: flex;
        flex-direction: row;
        /deep/ img {
            max-height: 300px;
            max-width: 70%;
        }
    }
    .message-item-footer {
        color: var(----G9, #191B1E);
        font-size: 12px;
        line-height: 16px; /* 133.333% */
    }
    .message-content-expand {
        position: relative;
        flex: 1;
        color: var(---G8, #545B66);
        line-height: var(--line-height);
        /deep/ a {
            color: #3A5BFD;
            // white-space: nowrap;
        }
    }

    .message-content {
        position: relative;
        flex: 1;
        color: var(---G8, #545B66);
        line-height: var(--line-height);
        // display: -webkit-box;
        overflow: hidden;
        word-break: break-all;
        line-break: anywhere; // 中文标点换行
        // -webkit-box-orient: vertical;
        // text-overflow: ellipsis;
        // -webkit-line-clamp: var(--max-line);
        /deep/ a {
            color: #3A5BFD;
            white-space: nowrap;
            &.a-float {
                z-index: 10;
                position: absolute;
                bottom: 0;
            }
        }
        &::before {
            content: "";
            float: right;
            width: 0;
            height: var(--ellipsis-top);
        }
        &::after {
            content: "...";
            position: absolute;
            right: 0;
            top: var(--ellipsis-top);
            width: var(--ellipsis-width);
        }
        /deep/.message-content-ellipsis {
            float: right;
            height: var(--line-height);
            clear: both;
        }
    }
    .expand-icon {
        cursor: pointer;
        color: #848B99;
        width: 18px;
        height: 18px;
        font-size: 18px;
        margin-left: 4px;
    }
}
</style>